import { Route, Routes, ScrollRestoration } from "react-router-dom";
import SelectBillType from "./payments/bills/SelectBillType";
// import DataBundles from "./payments/bills/DataBundles";
import DataBundlesTemp from "./payments/bills/DataBundlesTemp";
import AirtimeTemp from "./payments/bills/AirtimeTemp";
import CableTvTemp from "./payments/bills/CableTvTemp";
import ElectricityTemp from "./payments/bills/ElectricityTemp";
import ReferralRewards from "./payments/bills/ReferralRewards";

const PayBills = () => {
  return (
    <div className="relative min-h-[60vh]">
      <ScrollRestoration />
      <Routes>
        <Route path="/" element={<SelectBillType />} />
        <Route path="data" element={<DataBundlesTemp />} />
        {/* <Route path="data" element={<DataBundles />} /> */}
        <Route path="airtime" element={<AirtimeTemp />} />
        <Route path="electricity" element={<ElectricityTemp />} />
        <Route path="cable-tv" element={<CableTvTemp />} />
        <Route path="referral-rewards" element={<ReferralRewards />} />
        {/* E-Pin still coming soon */}
        <Route path="e-pin" element={<SelectBillType />} />
      </Routes>
    </div>
  );
};

export default PayBills;
